// Forwards every successful /cart/add.js → Shopify.analytics.publish('product_added_to_cart') AND fbq('track','AddToCart').
// Catches ATCs from theme, Upcart cart drawer, Kite auto-adds, and anything else that hits /cart/add.js.
(() => {
  const origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  window.fetch = async function(input, init) {
    const response = await origFetch.apply(this, arguments);
    try {
      const rawUrl = typeof input === 'string' ? input : (input && input.url) || '';
      const path = new URL(rawUrl, window.location.origin).pathname;
      if (path === '/cart/add.js' && response.ok) {
        response.clone().json().then((data) => {
          if (!data) return;
          const items = Array.isArray(data.items)
            ? data.items
            : (data.variant_id || data.id ? [data] : []);
          if (items.length === 0) return;

          const publish = window.Shopify?.analytics?.publish;
          const fbq = window.fbq;
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';

          items.forEach((item) => {
            const variantId = item.variant_id || item.id;
            const productId = item.product_id;
            const quantity = item.quantity || 1;
            const pricePence = typeof item.price === 'number' ? item.price : null;
            const priceMajor = pricePence !== null ? pricePence / 100 : null;

            // Shopify native analytics
            if (typeof publish === 'function') {
              try {
                publish('product_added_to_cart', {
                  variantId: variantId,
                  productId: productId,
                  quantity: quantity,
                });
              } catch (_) {}
            }

            // Meta Pixel AddToCart
            if (typeof fbq === 'function') {
              try {
                const payload = {
                  content_ids: [productId].filter(Boolean).map(String),
                  content_type: 'product',
                  contents: [{ id: String(productId), quantity: quantity }],
                };
                if (priceMajor !== null) {
                  payload.value = +(priceMajor * quantity).toFixed(2);
                  payload.currency = currency;
                }
                fbq('track', 'AddToCart', payload);
              } catch (_) {}
            }
          });
        }).catch(() => {});
      }
    } catch (_) {}
    return response;
  };
})();